<template>
  <div>
    <router-view class="view"></router-view>
  </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "katex/dist/katex.min.css";
import "./style.scss";

export default {
  name: "app",
  components: {},
  data() {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
.view {
  margin-top: 60px;
}
</style>
